import React, {useEffect, useState} from 'react';
import Accordion from 'react-bootstrap/Accordion';
import {Typography} from "@mui/material";
import BottomBorder from "../BottomBorder";
import {useApiService} from "../../context/ApiServiceContext";
import FAQ from "../../models/FAQ";
import aiMentionsFaqItems, {AiMentionsFaqItem} from "./aiMentionsFaqItems";

// The admin owns this list through /faq/list?section=ai-mentions. The six
// shipped questions are the fallback for a FAILED request only - they paint on
// the first frame and give way to whatever the server answers, including an
// authoritative empty section (an admin who deleted every question meant it),
// which hides the section instead of resurrecting deleted copy.
export const AI_MENTIONS_FAQ_URL = '/faq/list?section=ai-mentions&per_page=100';

const AiMentionsFaq: React.FC = () => {
    const apiService = useApiService();
    const [items, setItems] = useState<AiMentionsFaqItem[]>(aiMentionsFaqItems);

    useEffect(() => {
        let cancelled = false;

        apiService.api.get<FAQ[]>(AI_MENTIONS_FAQ_URL)
            .then(response => {
                if (cancelled || !Array.isArray(response.data)) {
                    return;
                }
                setItems(response.data.map(faq => ({
                    id: faq.id,
                    question: faq.title,
                    answer: faq.description ?? '',
                })));
            })
            .catch(error => {
                console.error("Fetching AI Mentions FAQs failed", error);
            });

        return () => {
            cancelled = true;
        };
    }, [apiService]);

    if (items.length === 0) {
        return null;
    }

    return (
        <section className="lnk-aim__faq">
            <div className="lnk-aim__title-block lnk-aim__title-block--center">
                <Typography variant="h2">מה עוד כדאי לדעת</Typography>
                <BottomBorder width={69} addMargin={false}/>
            </div>

            {/* The site's existing .faq-accordion look (plus/minus on the right,
                borderless), with alwaysOpen so several answers can stay open at
                once - the native <details> behaviour the handoff asked for.
                defaultActiveKey is read once per mount, so the accordion is
                keyed on the first item: swapping the shipped list for the
                published one re-opens the first question rather than none. */}
            <div className="lnk-aim__faq-list faq-accordion">
                <Accordion key={items[0].id} alwaysOpen defaultActiveKey={[items[0].id]}>
                    {items.map(item => (
                        <Accordion.Item eventKey={item.id} key={item.id}>
                            <Accordion.Header>{item.question}</Accordion.Header>
                            <Accordion.Body>
                                {/* Answers are authored in the admin's rich-text
                                    editor - rendered exactly like FAQAccordion */}
                                <p style={{whiteSpace: "pre-line"}}
                                   dangerouslySetInnerHTML={{__html: item.answer}}/>
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};

export default AiMentionsFaq;
